import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { CustomerData } from 'src/app/models/customer.model';
import { KnBrCartContextService } from 'src/app/store/kn-br-cart-context/kn-br-cart-context.service';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'context-change-modal',
    templateUrl: './context-change-modal.component.html',
    styleUrls: ['./context-change-modal.component.scss'],
    imports: [NgClass]
})
export class ContextModalComponent implements OnInit {
  url: string;
  attachmentName: string;
  subscription: any;
  soldToAccountsList;
  accountsList;
  newSoldTo = null;
  select = false;

  constructor(
    public activeModal: NgbModal,
    // private routingService: RoutingService,
    private messageService: GlobalMessageService,
    private customerContextService: KnBrCustomerContextService,
    private cartContextService: KnBrCartContextService
  ) {}

  ngOnInit(): void {
    this.accountsList = this.soldToAccountsList;
  }

  dismissModal(): void {
    this.activeModal.dismissAll();
  }

  selectSoldTo(newSoldto: CustomerData, index) {
    this.newSoldTo = newSoldto;
    this.select = index;
  }

  saveSoldToSelection() {
    localStorage.removeItem('spartacus⚿cwt-customer⚿cart');
    localStorage.removeItem('deliveryCompletedSteps');
    localStorage.removeItem('pickUpCompletedSteps');
    this.customerContextService.delete();
    this.cartContextService.delete();
    this.customerContextService.set(this.newSoldTo);
    this.dismissModal();
    this.messageService.add('Account is switched successfully.', GlobalMessageType.MSG_TYPE_CONFIRMATION);
    setTimeout(() => { window.location.reload()}, 600);
  }
} 
